import { Component, OnInit } from '@angular/core';
import { DialogRef } from "@fundamental-ngx/core/dialog";

export enum FileAction {
    OVERWRITE = 'overwrite',
    APPEND = 'append',
    CANCEL = 'cancel'
}

@Component({
    selector: 'app-confirm-overwrite-yaml-content',
    templateUrl: './confirm-overwrite-yaml-content.component.html',
    styleUrls: ['./confirm-overwrite-yaml-content.component.scss'],
    standalone: false
})
export class ConfirmOverwriteYamlContentComponent implements OnInit {
    public FileAction = FileAction;
    msg: string;
    title: string;

    constructor(
        public dialogRef: DialogRef
    ) {}

    ngOnInit(): void {
        this.msg = "The YAML editor currently has content.\n\nWould you like to append the uploaded content to what's already in the editor\n or overwrite the current content with the uploaded file?";
        this.title = "Upload Confirmation";
    }

    dismiss(action: FileAction): void {
        this.dialogRef.close(action);
    }

}
